<div class="dg-modal-header">
    <h2>{{popupTitle}}</h2>
    <i (click)="action(false)" (keydown.enter)="action(false)" tabindex="0" role="button" class="close-icon icon-cross_16px"></i>
</div>

<form [formGroup]="form" class="dg-modal-body">

    <span>Please select a new delivery location in the field below.</span>

    <div class="delivery-location">

        <b>Delivery location</b>
        <div class="dropdown-block">
            <div class="head" (click)="toggle()">
                <span [class.empty]="!FC.deliveryLocation.value">{{FC.deliveryLocation.value?.value || 'Select'}}</span>
                <i class="icon-arrow-expand arrow-icon" [class.opened]="isLocationDropdownOpen"></i>
            </div>
            <div *ngIf="isLocationDropdownOpen" class="list">
                <div class="search-wrapper">
                    <div class="search-section">
                        <input type="text"
                               [formControl]="FC.filterQuery"
                               (ngModelChange)="setFilterQuery($event)"
                               placeholder="Search"
                               maxlength="50"
                               (focus)="$event.stopPropagation()"
                               (click)="$event.stopPropagation()">
                        <i class="icon-search"></i>
                        <button id="clear-filter-search"
                                appTrackClickButton
                                type="button"
                                class="icon-cross_16px clear-control"
                                [hidden]="!FC.filterQuery.value.length"
                                (click)="$event.stopPropagation(); setFilterQuery('')">
                        </button>
                    </div>
                </div>

                <ng-container *ngTemplateOutlet="hasFilteredResults ? optionsList : emptyList"></ng-container>

                <ng-template #optionsList>
                    <div class="options-wrapper">
                        <div *ngFor="let option of deliveryLocations | listFilter: filterBy : false"
                             class="option"
                             (click)="locationChanged(option); toggle()">

                            <div class="option-label">
                                <span [innerHTML]="option.value | htmltransfrom | highlight: pipeFilterQuery"></span>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template #emptyList>
                    <div class="options-empty">No delivery locations found</div>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="tracking-id">

        <b>Tracking ID</b>

        <input type="text"
               [formControl]="FC.trackingId"
               [class.invalid]="FC.trackingId.invalid && isSubmitted"
               [placeholder]="'Enter tracking ID'"
               (input)="trim(FC.trackingId)">

        <div *ngIf="FC.trackingId.invalid && isSubmitted" class="error-message">
            <span *ngIf="FC.trackingId.errors.required">Required</span>
            <span *ngIf="!FC.trackingId.errors.required && FC.trackingId.errors.incorrectLength">Number of symbols should be 18 or 22</span>
        </div>
    </div>
</form>
<div class="dg-modal-footer">
    <button (click)="action(false)"
            appTrackClickButton
            id="dismiss"
            type="button"
            class="button secondary">{{ buttonsTitle.dismiss }}
    </button>

    <button (click)="submit()"
            appTrackClickButton
            id="confirm"
            type="button"
            class="button primary"
            [disabled]="!FC.deliveryLocation.value || !FC.trackingId.value">{{ buttonsTitle.confirm }}
    </button>
</div>
